import NewBrandPage from "../views/NewBrand";
import DashboardIcon from "@material-ui/icons/Dashboard";

export const brandRoutes = [
  {
    path: "/nuevo_marca",
    name: "Nueva Marca",
    icon: DashboardIcon,
    component: NewBrandPage,
    layout: "/admin",
    inSidebar: false,
  },
  {
    path: "/editar_marca/:isEdit/:id",
    name: "Editar marcas",
    icon: DashboardIcon,
    component: NewBrandPage,
    layout: "/admin",
    sublayout: "/editar_marca",
    isEdit: true,
    inSidebar: false,
  },
]